import type { TransformedRole, Role } from '../../common/types.tsx';

export const getFetchRolesURL = (projectKeyOrId: string): string =>
	`/rest/api/3/project/${projectKeyOrId}/internal/roledetails?excludeConnectAddons=true`;

export const transformRoleIdToString = (roles: Role[]): TransformedRole[] =>
	roles.map(({ id, ...role }) => ({
		roleId: id.toString(),
		...role,
	}));
